import React from 'react';
import { getUserById } from '../api';
import { useParams } from 'react-router-dom';
import { useState, useEffect } from 'react';


export function Userinfo() { 
    
    const [user, setUser] = useState([])    
    
    let params = useParams()
    let id = params.id
    
    useEffect(() => {
        async function loadUser() {
            const data = await getUserById(id)
            if (data) {
                setUser(data)
            }
        }
        loadUser()
    }, [id])

    return (
      <div> 
            <h1>{user.firstName} {user.lastName}</h1>
            <h2>{user.email}</h2>
            <h3>{user.occupation}</h3>
            <h4>{user.role}</h4>
            <h5>{user.practice}</h5>
            <h5>{user.password}</h5>
    </div>
   )
}

   